import React, { useState } from "react";
import { Pagination } from "antd";
import { message } from "antd";
import ReactLoading from "react-loading";
import { NavLink as Link } from "react-router-dom";
import { Tabs, Input } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { Tooltip } from "antd";

import { checkPermission } from "../../utils/checkPermission";
import { useEffect } from "react";

const CompletedCandidateList = ({candidateList}) => {
  const [canViewDocuments, setCanViewDocuments] = useState(false);
  const [current, setCurrent] = useState(1);

  useEffect(() => {
    const role = localStorage.getItem("user.role");
    if (role) {
      checkPermission(role, "documents_module", "view_documents").then(setCanViewDocuments);
    }
  }, []);

  const onChange = (page) => {
    console.log(page);
    setCurrent(page);
  };

  return (
    <div className="card-body row p-3 border mb-2 bg-white cursor-pointer shadow-sm ">
      <table className="table bg-white ">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone No</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {candidateList?.map((ele) => {
            return (
              <tr>
                <td>{ele?.candidateId?.name}</td>
                <td>{ele?.candidateId?.email}</td>
                <td>{ele?.candidateId?.mobileNo}</td>
                <td>
                  {canViewDocuments && (
                    <Link
                      to={{
                        pathname:
                          "/documents/verify/candidate/" + ele?.candidateId?._id,
                        state: {
                          candidateId: ele?.candidateId?._id,
                        },
                      }}
                    >
                      <button
                        class="btn btn-sm btn-primary btn-table-control mx-1"
                      >
                        View
                      </button>
                    </Link>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination current={current} onChange={onChange} total={50} />
    </div>
  );
};

export default CompletedCandidateList;
